import { useState } from "react";
import { Lightbox } from "react-modal-image";


const ColorImage = ({ colors }) => {
  const [showLightbox, setShowlightbox] = useState(false)
  return <div className={`flex ${colors.images && colors.images.length > 1 ? 'lg:h-[65vh]  my-1 h-44' : ''} shrink-0 relative overflow-x-auto`}>

    <div className=" ">

      {
        showLightbox ? <Lightbox
          medium={colors.imageUrl}
          large={colors.imageUrl}
          onClose={() => {
            setShowlightbox(false)
          }}
        /> : null
      }
      <div className="flex justify-start ">
        {colors.images ? <div className="flex justify-start ">
          {colors.images.slice(1).map(image => <img
            src={image.imageUrl}
            className="max-h-[90vh] h-full lg:h-[75vh] w-auto mx-2"
            onClick={() => {
              setShowlightbox(true);
            }}
          />)}

        </div> : null
        }
      </div>

      <div className="lg:absolute w-full bottom-0 left-0">
        <div className="flex">
          {colors && colors.colors && colors.colors.map((image, i) => <div className="w-full p-2 block group-hover:block bottom-0 bg-slate-100/60 z-10 " key={i} >
            <p><span className="underline font-semibold">Color: </span> {image.color}</p>
            {image.rogRank ? <p><span className="underline font-semibold">15-day ROG Rank: </span> {image.rogRank}</p> : null}
            {image.depthRank ? <p><span className="underline font-semibold">15-day Dominance Rank: </span> {image.depthRank}</p> : null}
          </div>)}
        </div>
      </div>
    </div>
  </div>
}


export default ColorImage
